import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class TrainingModulesService {
  fetchIndex(storeIds) {
    return securedAxiosInstance.get("/training_modules", { params: toSnakeCase({ storeIds }) });
  }

  fetchStoresCompletion(storeIds) {
    return securedAxiosInstance.get("/training_modules/stores_completion", { params: toSnakeCase({ storeIds }) });
  }

  fetch(moduleId) {
    return securedAxiosInstance.get(`/training_modules/${moduleId}`);
  }
}

export default new TrainingModulesService();
